import { ref, watch, toValue } from 'vue';
import followUpCadenceRunsAPI from 'dashboard/api/followUpCadenceRuns';

// Estados que ainda podem ser cancelados/avançados — espelha
// FollowUpCadenceRun::NON_TERMINAL_STATUSES (Ruby). Um run finished_*/
// opted_out/escalated_human não é mais "em follow-up" pro usuário, mesmo
// que o registro histórico continue existindo.
const NON_TERMINAL_STATUSES = ['active', 'paused_manual', 'awaiting_approval'];

// Pedido do Victor (2026-07-22): ver no header e na sidebar da conversa se
// ela está em follow-up, sem precisar abrir o painel separado
// (/follow-ups/cadences). Busca só quando a conversa muda — 1 request leve
// por abertura de conversa, não fica passando por cima da conexão real-time
// existente (não mexe em push_event_data/Conversations::EventDataPresenter,
// que tem blast radius grande demais pra essa necessidade).
export function useFollowUpStatus(conversationId) {
  const run = ref(null);
  const isLoading = ref(false);

  const fetchStatus = async () => {
    const id = toValue(conversationId);
    if (!id) {
      run.value = null;
      return;
    }
    isLoading.value = true;
    try {
      const { data } = await followUpCadenceRunsAPI.get({
        conversation_id: id,
      });
      run.value =
        (data || []).find(r => NON_TERMINAL_STATUSES.includes(r.status)) ||
        null;
    } catch {
      run.value = null;
    } finally {
      isLoading.value = false;
    }
  };

  watch(() => toValue(conversationId), fetchStatus, { immediate: true });

  return { run, isLoading, refetch: fetchStatus };
}
